module.exports = __webpack_public_path__ + "static/img/tutorial3_2.0bcd04a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_dealer/tutorial3_2.png
// module id = cWyU
// module chunks = 0